import React from 'react';
import MainCard from 'components/MainCard';
import Typography from '@mui/material/Typography';

export default function About() {
  return (
    <MainCard title="About Us">
      <Typography variant="body1" color="text.secondary">
        This is a placeholder About Us page. Replace this text with your company story, mission, and team details.
      </Typography>
    </MainCard>
  );
}


